import React, { useState, useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
// import 'bootstrap/dist/css/bootstrap.min.css';
import '../Finance/Fdashboard.css';
import Header from "../Finance/Fheader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPersonCircleCheck,
  faMoneyBillTransfer,
  faComment,
  faBookOpenReader,
  faChalkboardUser,
  faHourglassHalf,
  faCalendarAlt,
  faMoneyCheckDollar,
  faMoneyBill,
} from "@fortawesome/free-solid-svg-icons";
import "react-calendar/dist/Calendar.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import LearnImage from '../images/Learn.jpeg'
import LearnImage from "../images/learn.jpg";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Link } from "react-router-dom";
import { faMapMarkerAlt, faPhone } from "@fortawesome/free-solid-svg-icons";
import axios, { renderDoc } from "../Axiosinstance";
import Cap from "../images/Cap.jpg";
import { encryptData } from "../Axiosinstance";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  TablePagination,
  Card,
  CardContent,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  DialogContentText,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";

import { Modal, Spinner } from "react-bootstrap";
import Button from '@mui/material/Button';
import Loader from "../Loader";
import {
  faUserGraduate,
  faUserTie,
  faLayerGroup,
  faChalkboard,
  faBook,
} from "@fortawesome/free-solid-svg-icons";
 import Studentreq from "../components/Studentreq";
 import StudentPayment from "../components/StudentPayments";
import { Tabs, Tab, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  faTasks,
  faProjectDiagram,
  faBell,
  faTicketAlt,
  faBullhorn,
  faTable,
} from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPaginate from "react-paginate";
import { FaChalkboardTeacher } from "react-icons/fa";
import { format } from "date-fns";
 import Editstudent from "../components/EditStudent";
 import Offlinepayments from "../components/Offlinepayments";
import Defferred from "../components/Defferred";
import Enqiuery from "../components/Enqiuery";
import CircularProgress from "@material-ui/core/CircularProgress";
import { removeBracketedText } from "../Axiosinstance";
import Pending from "../components/Pending";
// import { CategoryStudentWise } from "./CategoryStudentWise";
import * as XLSX from "xlsx";

const Ap = () => {
  return (
    <div className="containerd" style={{ textAlign: 'center', padding: '35px', marginTop: '-2%' }} >
      <h1
        className="welcome-heading"
        style={{

          color: "#2186C8",
          fontSize: "2.5rem",
          fontWeight: "bold",
          textShadow:
            "2px 2px 0px white, -2px -2px 0px white, 2px -2px 0px white, -2px 2px 0px white",
        }}
      >
        <span id="head" style={{ color: "#2186C8" }}>
          JURONG ACADEMY
        </span>
      </h1>
      <h4
        className="welcome-heading"
        style={{
          color: "#d4af37",
          fontSize: "1.0rem",
          fontWeight: "bold",
          marginBottom: "10px",
        }}
      >
        Student Learning Management System
      </h4>
    </div>
  );
};

const Dashboard = () => {
  const [studentdata1, setstudentdata1] = useState(0);
  const [staffdata2, setstaffdata2] = useState(0);
  const [batchdata3, setbatchdata3] = useState(0);
  const [coursesdata4, setcoursesdata4] = useState(0);
  const [activeStudent, setActiveStudent] = useState(0);
  
  const [counts, setCounts] = useState(0);
  const [showStudentReq, setShowStudentReq] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          response1,
          response2,
          response3,
          response4,
          response5,
          response6,
        ] = await Promise.all([
          axios.get("student/count"),
          axios.get("facilitator/count"),
          axios.get("course/count"),
          axios.get("category/count"),
          axios.get("courses/countByType"),
          axios.get("student/count/active"),
        ]);
        setstudentdata1(response1.data);
        setstaffdata2(response2.data);
        setbatchdata3(response3.data);
        setcoursesdata4(response4.data);
        setCounts(response5.data);
        setActiveStudent(response6.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    console.log("showStudentReq changed:", showStudentReq);
  }, [showStudentReq]);


  const handleOpenStudentReq = () => {
    setShowStudentReq(true); // Open the modal
  };

  const handleCloseStudentReq = () => {
    setShowStudentReq(false); // Close the modal
  };
  const totals = [
    // { name: 'Total Students', count: studentdata1, icon: faUserGraduate, path: '/Allstudent' },
    {
      name: "Active Students",
      count: activeStudent,
      icon: faUserGraduate,
      path: "/Allstudent",
    },
    {
      name: "Offline Payments",
      count: staffdata2,
      icon: faMoneyCheckDollar,
    // path: "/Studentreq",
   onClick: handleOpenStudentReq,
    },
    // { name: 'Department wise Student', count: 30, icon: faLayerGroup, path: '/Allstudent' },
    {
      name: "Diploma Courses",
      count: counts.diploma,
      icon: faBookOpenReader,
      path: "/AllCourse",
      type: "diploma",
    },
    {
      name: "Advance Diploma ",
      count: counts.advance_diploma,
      icon: faBook,
      path: "/AllCourse",
      type: "advance_diploma",
    },
    {
      name: "Payment Log ",
      // count: counts.advance_diploma,
      icon: faBook,
      path: "/paymentlog",
      //   type: "advance_diploma",
    },
    // {
    //   name: "Alumini ",
    //   // count: counts.advance_diploma,
    //   icon: faUserGraduate,
    //   path: "/AluminiDetails",
    // }
  ];

  const handleNavigation = (path, params = {}) => {
    if (path === "/AllCourse") {
      const searchParams = new URLSearchParams(params).toString();
      navigate(`${path}?${searchParams}`);
    } else {
      navigate(path);
    }
  };
 
  const [hoverIndex, setHoverIndex] = useState(null);

  return (
    <div
  style={{
    display: "flex",
    justifyContent: "center", // Centers horizontally
    alignItems: "center",
    minHeight: "30vh",
  }}
>
<div
      style={{
        display: 'flex',
        flexWrap: 'wrap', // Allow items to wrap on smaller screens
        justifyContent: 'center',
        padding: '30px',
        backgroundColor: 'rgba(255, 255, 255, 0.3)', // White with 50% opacity
        borderRadius: '10px',
        boxShadow: '0 8px 15px rgba(0, 0, 0, 0.2)', // Shadow effect
        maxWidth: '1200px',
        margin: '0 auto',
        gap: '20px', // Added gap between cards
      }}
    >
      {totals.map((item, index) => (
        <div
          key={index}
          onClick={() => {
            if (item.onClick) {
              item.onClick();
            } else {
              handleNavigation(item.path, { courseType: item.type }); // Handle navigation
            }
          }}
          onMouseEnter={() => setHoverIndex(index)}
          onMouseLeave={() => setHoverIndex(null)}
          style={{
            display: 'flex',
            alignItems: 'center',
            borderRadius: '12px',
            overflow: 'hidden',
            cursor: 'pointer',
            boxShadow:
              hoverIndex === index
                ? '0 10px 20px rgba(0, 0, 0, 0.15)'
                : '0 4px 8px rgba(0, 0, 0, 0.1)',
            backgroundColor: '#f5f5f5',
            transition: 'transform 0.4s ease',
            transform: hoverIndex === index ? 'scale(1.05)' : 'scale(1)',
            width: '350px', // Set a fixed width for each card
            height: '105px', // Fixed height for consistency
            justifySelf: 'stretch',
          }}
        >
          {/* Left Icon Panel */}
          <div
            style={{
              width: '120px',
              height: '100px',
              backgroundColor: hoverIndex === index ? '#0277bd' : '#d18828',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#fff',
            }}
          >
            <FontAwesomeIcon icon={item.icon} style={{ fontSize: '28px' }} />
          </div>
          {/* Right Data Panel */}
          <div style={{ flex: 1, padding: '20px' }}>
            <div
              style={{ fontSize: '24px', fontWeight: '600', color: '#37474f' }}
            >
              {item.count}
            </div>
            <div
              style={{
                fontSize: '16px',
                fontWeight: 'bolder',
                color: '#122c4a',
              }}
            >
              {item.name}
            </div>
          </div>
        </div>
      ))}
    </div>
        <Modal
        show={showStudentReq}
        onHide={handleCloseStudentReq}
        dialogClassName="modal-fullscreen"
      >
        <Modal.Header closeButton>
          <Modal.Title>Offline Payments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Studentreq />
          <ToastContainer />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" color="error" style={{minWidth:'100px'}} onClick={handleCloseStudentReq}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    
  );
};

const Adhome = () => {
  return (
    <div style={{
      position: 'relative',
      
      // Prevents content overflow
    }}>
      {/* Full-screen background */}
      <div style={{
        backgroundColor: '#285588', // Consistent color
        width: '100%',  // Stretches to full width
        height: '100%', // Stretches to full height
        position: 'fixed', // Ensures it stays in place across views
        top: 0,
        left: 0,
        zIndex: -1, // Ensures it is below all content
      }} />

      {/* Content */}
      <div style={{
        position: 'relative', // Ensures content stays above the background
        zIndex: 1,
      }}>

        <Header />
        <br />
        <div style={{ flexDirection: "column", alignItems: "center" }}>
          <Ap />
          <br />
          <Dashboard />
          
          <br />
          {/* <App /> */}
        </div>
        <br />
        {/* <div
          style={{
            maxWidth: '1300px',
            margin: '0 auto',
            position: 'relative', // Position for absolute positioning of common name
            backgroundColor: 'rgba(255, 255, 255, 0.3)', // White with 50% opacity
            borderRadius: '10px',
            boxShadow: '0 8px 15px rgba(0, 0, 0, 0.2)', // Shadow effect
            padding: '10px', // Optional: for spacing
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Optional: shadow effect
          }}
       
        >
          <div
            style={{
              position: 'absolute',
              color: 'white',
              top: '16px',
              left: '16px',
              fontWeight: 'bold',
              fontSize: '1.6em', // Adjust the size as needed
              zIndex: 1, // Ensure it is above other content
            }}
          >
            Course Catergories
          </div>
       
          <CategoryStudentWise />
        </div> */}
      </div>
    </div>
  );
};

export default Adhome;
